import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export type SerializedError = {
  cause?: unknown;
  code?: string;
  message?: string;
  name?: string;
  sagaStack?: string;
  stack?: string;
};

export type ErrorState = {
  fatalError: SerializedError | null;
};

const initialState: ErrorState = {
  fatalError: null,
};

export const errorSlice = createSlice({
  initialState,
  name: 'error',
  reducers: {
    setFatalError: (state, action: PayloadAction<SerializedError>) => {
      state.fatalError = action.payload;
    },
  },
});
